<template>
    <component :is="tag" v-bind="wrapperProps">
        <label>{{ lang.invoice_class }}</label>
        <b-form-select
            class="selborder"
            :value="value"
            :options="invoiceClasses"
            :disabled="disabled"
            @change="onChange"
        ></b-form-select>
    </component>
</template>

<script>
import axios from 'axios';

// The invoice classification (maintenance / rental / ...) used to be a per-user setting.
// It lives on the invoice now, so every screen that creates or shows an invoice mounts
// this picker and reads the same userInvoiceType option list.
export default {
    name: 'invoiceClassSelect',
    props: {
        value: {
            default: 0
        },
        // Rendered as a v-col by default so it drops straight into the invoice form rows;
        // pass tag="div" where the caller is not inside a v-row.
        tag: {
            type: String,
            default: 'v-col'
        },
        cols: {
            default: 12
        },
        md: {
            default: 2
        },
        sm: {
            default: 6
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            invClasses: []
        }
    },
    computed: {
        wrapperProps: function(){
            if(this.tag !== 'v-col'){
                return {};
            }
            return {cols: this.cols, md: this.md, sm: this.sm, xs: 12};
        },
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki) == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki) == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            return this.$store.state.lang.ar;
        },
        invoiceClasses: function(){
            let t = [{text: this.lang.chose_invoice_class, value: 0}];
            for(let i = 0; i < this.invClasses.length; i++){
                t.push({
                    text: this.invClasses[i][`name_${this.lang.langname}`],
                    value: parseInt(this.invClasses[i].value)
                })
            }
            return t;
        }
    },
    methods: {
        onChange(v){
            this.$emit('input', parseInt(v || 0));
            this.$emit('change', parseInt(v || 0));
        },
        getInvoiceClasses(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getStaticOptions");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[phrase]","userInvoiceType");
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((res) => {
                if(res && res.data && res.data.results){
                    this.invClasses = res.data.results.data || [];
                }
            });
        }
    },
    created() {
        this.getInvoiceClasses();
    }
}
</script>
